import React, { useContext } from 'react';
import { Label, Table } from 'reactstrap';
import { H6, P } from '../../../AbstractElements';
import CartContext from '../../../Context/Ecommerce/Cart';

const InvoiceMainTable = () => {
  const { cart, cartTotal } = useContext(CartContext);

  return (
    <>
      <div className='invoice-table'>
        <Table responsive className='table-bordered table-striped'>
          <tbody>
            <tr>
              <td className='item'>
                <H6 className='p-2 mb-0'>Item Description</H6>
              </td>
              <td className='Hours'>
                <H6 className='p-2 mb-0'>Hours</H6>
              </td>
              <td className='Rate'>
                <H6 className='p-2 mb-0'>Rate</H6>
              </td>
              <td className='subtotal'>
                <H6 className='p-2 mb-0'>Sub-total</H6>
              </td>
            </tr>

            {cart &&
              cart.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Label>{item.name}</Label>
                    <P className='m-0'>{item.discription}</P>
                  </td>
                  <td>
                    <P className='itemtext digits'>{item.qty}</P>
                  </td>
                  <td>
                    <P className='itemtext digits'>${item.price}</P>
                  </td>
                  <td>
                    <P className='itemtext digits'>${item.price * item.qty}</P>
                  </td>
                </tr>
              ))}
            <tr>
              <td></td>
              <td></td>
              <td className='Rate'>
                <H6 className='mb-0 p-2'>Total</H6>
              </td>
              <td className='payment digits'>
                <H6 className='mb-0 p-2'>${cartTotal}</H6>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default InvoiceMainTable;
